export const OurResults = [
  {
    id: 1,
    result: `Trusted by<br/> <span style="font-size: 24px; font-weight: 600;">1000+</span> Clients`,
    resultImg: '/images/category/web-design.png',
  },
  {
    id: 2,
    result: `Over <span style="font-size: 24px; font-weight: 600;">1400+</span><br/> Projects`,
    resultImg: '/images/category/web-design.png',
  },
  {
    id: 3,
    result:
      '<span style="font-size: 24px; font-weight: 600;">19+</span> Years of<br/> Excellence',
    resultImg: '/images/category/web-design.png',
  },
  {
    id: 4,
    result: `<span style="font-size: 24px; font-weight: 600;">50+</span> In-House<br/> Experts`,
    resultImg: '/images/category/web-design.png',
  },
];

export const Services = [
  {
    id: 1,
    service: 'Branding',
    cateSmallImg: '/images/service/service-1.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 2,
    service: 'Logo design',
    cateSmallImg: '/images/service/service-2.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 3,
    service: 'Brochure Design',
    cateSmallImg: '/images/service/service-3.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 4,
    service: 'Website Design',
    cateSmallImg: '/images/service/service-4.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 5,
    service: 'CMS Website<br/> Development',
    cateSmallImg: '/images/service/service-5.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 6,
    service: 'Ecommerce<br/> Development',
    cateSmallImg: '/images/service/service-6.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 7,
    service: 'Search Engine<br/> Optimization',
    cateSmallImg: '/images/service/service-7.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 8,
    service: 'Social Media<br/> Marketing',
    cateSmallImg: '/images/service/service-8.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 9,
    service: 'Pay<br/>Per-Click',
    cateSmallImg: '/images/service/service-9.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 10,
    service: 'Mobile App<br/> Development',
    cateSmallImg: '/images/service/service-10.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 11,
    service: 'Market Place<br/> Services',
    cateSmallImg: '/images/service/service-11.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 12,
    service: 'Corporate<br/> Video',
    cateSmallImg: '/images/service/service-12.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
];

export const WebServices = [
  {
    id: 1,
    service: 'Ecommerce Website<br> Development',
    cateSmallImg: '/images/service/ecommerce-website-development.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 2,
    service: 'Wordpress Website<br> Development',
    cateSmallImg: '/images/service/wordpress-website-development.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 3,
    service: 'Static Website<br> Development',
    cateSmallImg: '/images/service/Static-website-development.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 4,
    service: 'Dynamic Website<br> Development',
    cateSmallImg: '/images/service/Dynamic-website-developent.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 5,
    service: 'Custom Website<br> Development',
    cateSmallImg: '/images/service/Custom-website-development.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 6,
    service: 'Web App<br> Development',
    cateSmallImg: '/images/service/web-app-development.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 7,
    service: 'Website Design &<br> Maintenance',
    cateSmallImg: '/images/service/website-design-maintance.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  {
    id: 8,
    service: 'CRM Integration<br> Services',
    cateSmallImg: '/images/service/crm-intergration-services.png',
    cateBigImg: '/images/category/image/web-design.jpg',
  },
  // {
  //   id: 9,
  //   service: "Pay<br/>Per-Click",
  //   cateSmallImg: "/images/service/service-9.png",
  //   cateBigImg: "/images/category/image/web-design.jpg",
  // },
  // {
  //   id: 10,
  //   service: "Mobile App<br/> Development",
  //   cateSmallImg: "/images/service/service-10.png",
  //   cateBigImg: "/images/category/image/web-design.jpg",
  // },
  // {
  //   id: 11,
  //   service: "Market Place<br/> Services",
  //   cateSmallImg: "/images/service/service-11.png",
  //   cateBigImg: "/images/category/image/web-design.jpg",
  // },
  // {
  //   id: 12,
  //   service: "Corporate<br/> Video",
  //   cateSmallImg: "/images/service/service-12.png",
  //   cateBigImg: "/images/category/image/web-design.jpg",
  // },
];

export const WebService = [
  {
    id: 1,
    service: 'Sree Thangam Jewellery',
    cateSmallImg: '/images/service/thanga-jewell.jpg',
    cateBigImg: '/images/category/image/web-design.jpg',
    link: 'https://sreethangamjewellery.com/',
  },
  {
    id: 2,
     service: 'Prade Jewellery',
    cateSmallImg: '/images/service/prade.jpg',
    cateBigImg: '/images/category/image/web-design.jpg',
    link: 'https://prade.in/',
  },
  {
    id: 3,
    service: 'Dream Warrior Pictures',
    cateSmallImg: '/images/service/dwp.jpg',
    cateBigImg: '/images/category/image/web-design.jpg',
    link: 'https://www.dwp.in/',
  },
  {
    id: 4,
    service: 'KCE',
    cateSmallImg: '/images/service/kce.jpg',
    cateBigImg: '/images/category/image/web-design.jpg',
    link: 'https://kce.ac.in/',
  },
  {
    id: 5,
    service: 'KIT',
    cateSmallImg: '/images/service/kit.jpg',
    cateBigImg: '/images/category/image/web-design.jpg',
    link: 'https://karpagamtech.ac.in/',
  },
  {
    id: 6,
    service: 'Thangam Cancer Centre',
    cateSmallImg: '/images/service/thangam-care.jpg',
    cateBigImg: '/images/category/image/web-design.jpg',
    link: 'https://thangamcancercenter.com/',
  },
  {
    id: 7,
    service: 'KPR Mills',
    cateSmallImg: '/images/service/kpr-mill.jpg',
    cateBigImg: '/images/category/image/web-design.jpg',
    link: 'https://kprmilllimited.com/',
  },
  {
    id: 8,
    service: 'MMHRC',
    cateSmallImg: '/images/service/mmhrc.jpg',
    cateBigImg: '/images/category/image/web-design.jpg',
    link: 'https://mmhrc.in/',
  },
  // {
  //   id: 9,
  //   service: "Pay<br/>Per-Click",
  //   cateSmallImg: "/images/service/service-9.png",
  //   cateBigImg: "/images/category/image/web-design.jpg",
  // },
  // {
  //   id: 10,
  //   service: "Mobile App<br/> Development",
  //   cateSmallImg: "/images/service/service-10.png",
  //   cateBigImg: "/images/category/image/web-design.jpg",
  // },
  // {
  //   id: 11,
  //   service: "Market Place<br/> Services",
  //   cateSmallImg: "/images/service/service-11.png",
  //   cateBigImg: "/images/category/image/web-design.jpg",
  // },
  // {
  //   id: 12,
  //   service: "Corporate<br/> Video",
  //   cateSmallImg: "/images/service/service-12.png",
  //   cateBigImg: "/images/category/image/web-design.jpg",
  // },
];

export const Industries = [
  {
    id: 1,
    industry: 'B2B',
    img: '/images/category/b2b.png',
  },
  {
    id: 2,
    industry: 'Education',
    img: '/images/category/education.png',
  },
  {
    id: 3,
    industry: 'Ecommerce',
    img: '/images/category/ecommerce.png',
  },
  {
    id: 4,
    industry: 'Real Estate',
    img: '/images/category/real-estate.png',
  },
  {
    id: 5,
    industry: 'Healthcare',
    img: '/images/category/healthcare.png',
  },
  {
    id: 6,
    industry: 'Manufacturing',
    img: '/images/category/Manufacturing.png',
  },
  {
    id: 7,
    industry: 'Textile',
    img: '/images/category/textile.png',
  },

  {
    id: 8,
    industry: 'FMCG & Retail',
    img: '/images/category/fmcg.png',
  },
  // {
  //   id: 5,
  //   industry: "Food",
  //   img: "/images/category/food.png",
  // },
  // {
  //   id: 9,
  //   industry: "Jewellery",
  //   img: "/images/category/jewelley.png",
  // },
  // {
  //   id: 10,
  //   industry: "Machine Accessories",
  //   img: "/images/category/machine-accessories.png",
  // },
];

export const OurClients = [
  {
    id: 1,
    img: '/images/brand/brand-01.png',
  },
  {
    id: 2,
    img: '/images/brand/brand-02.png',
  },
  {
    id: 3,
    img: '/images/brand/brand-03.png',
  },
  {
    id: 4,
    img: '/images/brand/brand-04.png',
  },
  {
    id: 5,
    img: '/images/brand/brand-05.png',
  },
  {
    id: 6,
    img: '/images/brand/brand-06.png',
  },
];

export const socialLink = [
  {
    id: 1,
    icon: 'feather-facebook',
    link: 'https://www.facebook.com/ireputeagency/',
  },

  {
    id: 2,
    icon: 'feather-twitter',
    link: 'https://twitter.com/ireputeagency',
  },
  {
    id: 3,
    icon: 'feather-instagram',
    link: 'https://www.instagram.com/ireputeagency/',
  },
  {
    id: 4,
    icon: 'feather-linkedin',
    link: 'https://www.linkedin.com/company/irepute-agency/',
  },
  {
    id: 5,
    icon: 'feather-youtube',
    link: 'https://www.youtube.com/@ireputeagency',
    // link:"https://web.whatsapp.com/send?phone=7871207631&text=",
  },
];
